/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */
import {
    HttpClient,
    HttpHeaders,
    HttpResponse as AngularHttpResponse,
} from '@angular/common/http';
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
    AssignDocumentPackDocumentRequest,
    AssignDocumentPackDocumentsBatchRequest,
    AssignDocumentPackDocumentsBatchResponse,
    BuildingAddressSelectionResponse,
    BuildingAddressSuggestionsResponse,
    BuildingContactListResponse,
    BuildingContactResponse,
    BuildingDetailsResponse,
    BuildingIntelligenceEnrichmentEligibilityResponse,
    BuildingIntelligenceEnrichmentJobResponse,
    BuildingListResponse,
    BuildingLogListResponse,
    BuildingOwnershipTransferResponse,
    BuildingProfileEvidenceIndexResponse,
    BuildingProfileEvidenceSourcesResponse,
    BuildingResponse,
    CreateBuildingContactRequest,
    CreateBuildingRequest,
    CreateDocumentPackRequest,
    CreateDocumentPackResponse,
    DecideBuildingProfilePropertyRequest,
    DecideBuildingProfilePropertyResponse,
    DocumentBatchStatusResponse,
    DocumentExportStatusResponse,
    DocumentPackListResponse,
    DocumentPackResponse,
    DocumentPackSuggestionsResponse,
    DocumentPreviewFeedbackResponse,
    DocumentPreviewResponse,
    DocumentPreviewRetryResponse,
    DocumentPreviewViewUrlResponse,
    DuplicateDocumentPackRequest,
    DuplicateDocumentPackResponse,
    EditBuildingContactRequest,
    EditBuildingRequest,
    GetBuildingDocumentPackApprovalHistoryParams,
    GetBuildingDocumentPackExportByIdParams,
    GetBuildingDocumentPackExportDownloadParams,
    GetBuildingIntegrityDetailsResponse,
    GetBuildingIntegrityTrendResponse,
    GetBuildingIntelligenceEntitiesResponse,
    GetBuildingIntelligenceProofReportParams,
    GetBuildingIntelligenceReportResponse,
    GetBuildingIntelligenceTimelineCalendarParams,
    GetBuildingIntelligenceTimelineParams,
    GetBuildingIntelligenceTimelineResponse,
    GetBuildingLogCalendarParams,
    GetBuildingLogCalendarResponse,
    GetBuildingLogParams,
    GetBuildingProfileResponse,
    GetBuildingProofReportResponse,
    GetBuildingTimelineCalendarResponse,
    ListBuildingAddresseSuggestionsParams,
    ListBuildingContactsParams,
    ListBuildingDocumentPackApprovalCandidatesParams,
    ListBuildingDocumentPacksParams,
    ListBuildingDocumentProcessingReceiptStatusParams,
    ListBuildingIntelligenceEntitiesParams,
    ListBuildingProfileEvidenceSourcesParams,
    ListBuildingsParams,
    OwnershipTransferRecipientPreviewRequest,
    OwnershipTransferRecipientPreviewResponse,
    PackApprovalCandidatesResponse,
    PackApprovalDecisionRequest,
    PackApprovalHistoryResponse,
    PackApprovalParticipantsRequest,
    PackApprovalReplacementRequest,
    PackApprovalResponse,
    RecipientBatchResponseOfShareDocumentPackResponse,
    RequestBuildingAccessRequest,
    RequestBuildingAccessResponse,
    ShareDocumentPackRequest,
    StartBuildingIntelligenceEnrichmentResponse,
    StartBuildingOwnershipTransferRequest,
    SubmitDocumentPreviewFeedbackRequest,
    SuggestDocumentPackDocumentsRequest,
    UpdateDocumentPackRequest,
    UploadAndAssignDocumentPackBatchRequest,
    UploadAndAssignDocumentPackBatchResponse,
    UploadAndAssignDocumentPackRequest,
    UploadAndAssignDocumentPackResponse,
} from '../core-models';

type AngularHttpScalar = string | number | boolean;

interface HttpClientOptions {
    readonly headers?: HttpHeaders | Record<string, string | string[]>;
    readonly context?: HttpContext;
    readonly params?:
        | HttpParams
        | Record<string, AngularHttpScalar | Array<AngularHttpScalar>>;
    readonly reportProgress?: boolean;
    readonly withCredentials?: boolean;
    readonly credentials?: RequestCredentials;
    readonly keepalive?: boolean;
    readonly priority?: RequestPriority;
    readonly cache?: RequestCache;
    readonly mode?: RequestMode;
    readonly redirect?: RequestRedirect;
    readonly referrer?: string;
    readonly integrity?: string;
    readonly referrerPolicy?: ReferrerPolicy;
    readonly transferCache?: { includeHeaders?: string[] } | boolean;
    readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
    readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
    readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
    readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
    readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = AngularHttpScalar | Array<AngularHttpScalar>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function isAngularHttpScalar(value: unknown): value is AngularHttpScalar {
    return (
        typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean'
    );
}

function filterAngularHttpArray(values: unknown[]): AngularHttpScalar[] {
    return values.filter(isAngularHttpScalar);
}

function copyDefinedAngularHttpParam(
    params: Record<string, unknown>,
    key: string,
    value: unknown
): void {
    if (value !== undefined) params[key] = value;
}

function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys?: ReadonlySet<string>,
    preserveRequiredNullables?: false,
    passthroughKeys?: undefined
): Record<string, AngularHttpParamValue>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> | undefined,
    preserveRequiredNullables: true,
    passthroughKeys?: undefined
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> | undefined,
    preserveRequiredNullables: boolean | undefined,
    passthroughKeys: ReadonlySet<string>
): Record<string, unknown>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> = new Set(),
    preserveRequiredNullables = false,
    passthroughKeys: ReadonlySet<string> = new Set()
): Record<string, unknown> {
    const filteredParams: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(params)) {
        if (passthroughKeys.has(key)) {
            copyDefinedAngularHttpParam(filteredParams, key, value);
            continue;
        }
        if (Array.isArray(value)) {
            const filtered = filterAngularHttpArray(value);
            if (filtered.length) {
                filteredParams[key] = filtered;
            }
        } else if (value === null && requiredNullableKeys.has(key)) {
            // With a paramsSerializer (preserveRequiredNullables) the literal null
            // is passed through for it to consume; without one, emit an empty
            // string so the required key still reaches the wire as `?key=`
            // instead of being silently dropped. See #3712.
            filteredParams[key] = preserveRequiredNullables ? null : '';
        } else if (isAngularHttpScalar(value)) {
            filteredParams[key] = value;
        }
    }
    return filteredParams;
}

type AngularHttpClientResult<T> = T | HttpEvent<T> | AngularHttpResponse<T>;

@Injectable({ providedIn: 'root' })
export class BuildingsApiService {
    private readonly http = inject(HttpClient);
    /**
     * Retrieves a paginated list of buildings the authenticated user has access to, with optional status, ownership, and search filtering.
     * @summary List buildings
     */
    listBuildings<TData = BuildingListResponse>(
        params: ListBuildingsParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildings<TData = BuildingListResponse>(
        params: ListBuildingsParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildings<TData = BuildingListResponse>(
        params: ListBuildingsParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildings<TData = BuildingListResponse>(
        params: ListBuildingsParams,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(`/@core/api/buildings`, {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'events',
                params: filteredParams,
            });
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(`/@core/api/buildings`, {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'response',
                params: filteredParams,
            });
        }

        return this.http.get<TData>(`/@core/api/buildings`, {
            ...(options as Omit<NonNullable<typeof options>, 'observe'>),
            observe: 'body',
            params: filteredParams,
        });
    }
    /**
     * Creates a new building and grants access to the creating user and organisation.
     * @summary Create building
     */
    createBuilding<TData = BuildingResponse>(
        createBuildingRequest: CreateBuildingRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuilding<TData = BuildingResponse>(
        createBuildingRequest: CreateBuildingRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuilding<TData = BuildingResponse>(
        createBuildingRequest: CreateBuildingRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuilding<TData = BuildingResponse>(
        createBuildingRequest: CreateBuildingRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings`,
                createBuildingRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings`,
                createBuildingRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings`,
            createBuildingRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Suggests recognised physical addresses, including units and primary addresses. Does not certify postal delivery.
     * @summary Suggest physical building addresses
     */
    listBuildingAddresseSuggestions<TData = BuildingAddressSuggestionsResponse>(
        params: ListBuildingAddresseSuggestionsParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildingAddresseSuggestions<TData = BuildingAddressSuggestionsResponse>(
        params: ListBuildingAddresseSuggestionsParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingAddresseSuggestions<TData = BuildingAddressSuggestionsResponse>(
        params: ListBuildingAddresseSuggestionsParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingAddresseSuggestions<TData = BuildingAddressSuggestionsResponse>(
        params: ListBuildingAddresseSuggestionsParams,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/addresses/suggestions`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/addresses/suggestions`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/addresses/suggestions`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Returns structured address components independently of optional building enrichment.
     * @summary Select a physical building address
     */
    getBuildingAddresseById<TData = BuildingAddressSelectionResponse>(
        addressId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingAddresseById<TData = BuildingAddressSelectionResponse>(
        addressId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingAddresseById<TData = BuildingAddressSelectionResponse>(
        addressId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingAddresseById<TData = BuildingAddressSelectionResponse>(
        addressId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/addresses/${addressId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/addresses/${addressId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/addresses/${addressId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Soft deletes a building when it is still in draft status.
     * @summary Delete draft building
     */
    removeBuilding<TData = void>(
        buildingId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    removeBuilding<TData = void>(
        buildingId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    removeBuilding<TData = void>(
        buildingId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    removeBuilding<TData = void>(
        buildingId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.delete<TData>(`/@core/api/buildings/${buildingId}`, {
            ...(options as Omit<NonNullable<typeof options>, 'observe'>),
            observe: 'body',
        });
    }
    /**
     * Retrieves a building by ID if the authenticated user has access to it.
     * @summary Get building details by ID
     */
    getBuildingById<TData = BuildingDetailsResponse>(
        buildingId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingById<TData = BuildingDetailsResponse>(
        buildingId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingById<TData = BuildingDetailsResponse>(
        buildingId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingById<TData = BuildingDetailsResponse>(
        buildingId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(`/@core/api/buildings/${buildingId}`, {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'events',
            });
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(`/@core/api/buildings/${buildingId}`, {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'response',
            });
        }

        return this.http.get<TData>(`/@core/api/buildings/${buildingId}`, {
            ...(options as Omit<NonNullable<typeof options>, 'observe'>),
            observe: 'body',
        });
    }
    /**
     * Updates editable overview details for a building when the authenticated user has access.
     * @summary Edit building
     */
    updateBuilding<TData = BuildingResponse>(
        buildingId: string,
        editBuildingRequest: EditBuildingRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    updateBuilding<TData = BuildingResponse>(
        buildingId: string,
        editBuildingRequest: EditBuildingRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    updateBuilding<TData = BuildingResponse>(
        buildingId: string,
        editBuildingRequest: EditBuildingRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    updateBuilding<TData = BuildingResponse>(
        buildingId: string,
        editBuildingRequest: EditBuildingRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}`,
                editBuildingRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}`,
                editBuildingRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.put<TData>(
            `/@core/api/buildings/${buildingId}`,
            editBuildingRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * A request grants no access. Members whose organisation already has access are routed to their own administrator.
     * @summary Request organisation access to a published building
     */
    createBuildingAccessRequest<TData = RequestBuildingAccessResponse>(
        buildingId: string,
        requestBuildingAccessRequest: RequestBuildingAccessRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingAccessRequest<TData = RequestBuildingAccessResponse>(
        buildingId: string,
        requestBuildingAccessRequest: RequestBuildingAccessRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingAccessRequest<TData = RequestBuildingAccessResponse>(
        buildingId: string,
        requestBuildingAccessRequest: RequestBuildingAccessRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingAccessRequest<TData = RequestBuildingAccessResponse>(
        buildingId: string,
        requestBuildingAccessRequest: RequestBuildingAccessRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/access-requests`,
                requestBuildingAccessRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/access-requests`,
                requestBuildingAccessRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/access-requests`,
            requestBuildingAccessRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Retrieves a paginated list of contacts for a specific building if the authenticated user has access.
     * @summary List building contacts
     */
    listBuildingContacts<TData = BuildingContactListResponse>(
        buildingId: string,
        params: ListBuildingContactsParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildingContacts<TData = BuildingContactListResponse>(
        buildingId: string,
        params: ListBuildingContactsParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingContacts<TData = BuildingContactListResponse>(
        buildingId: string,
        params: ListBuildingContactsParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingContacts<TData = BuildingContactListResponse>(
        buildingId: string,
        params: ListBuildingContactsParams,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/contacts`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/contacts`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/contacts`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Creates a new contact for a specific building.
     * @summary Add building contact
     */
    createBuildingContact<TData = BuildingContactResponse>(
        buildingId: string,
        createBuildingContactRequest: CreateBuildingContactRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingContact<TData = BuildingContactResponse>(
        buildingId: string,
        createBuildingContactRequest: CreateBuildingContactRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingContact<TData = BuildingContactResponse>(
        buildingId: string,
        createBuildingContactRequest: CreateBuildingContactRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingContact<TData = BuildingContactResponse>(
        buildingId: string,
        createBuildingContactRequest: CreateBuildingContactRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/contacts`,
                createBuildingContactRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/contacts`,
                createBuildingContactRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/contacts`,
            createBuildingContactRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Deletes an existing contact for a specific building.
     * @summary Delete building contact
     */
    removeBuildingContact<TData = void>(
        buildingId: string,
        contactId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    removeBuildingContact<TData = void>(
        buildingId: string,
        contactId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    removeBuildingContact<TData = void>(
        buildingId: string,
        contactId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    removeBuildingContact<TData = void>(
        buildingId: string,
        contactId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}/contacts/${contactId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}/contacts/${contactId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.delete<TData>(
            `/@core/api/buildings/${buildingId}/contacts/${contactId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Updates an existing contact for a specific building.
     * @summary Edit building contact
     */
    updateBuildingContact<TData = BuildingContactResponse>(
        buildingId: string,
        contactId: string,
        editBuildingContactRequest: EditBuildingContactRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    updateBuildingContact<TData = BuildingContactResponse>(
        buildingId: string,
        contactId: string,
        editBuildingContactRequest: EditBuildingContactRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    updateBuildingContact<TData = BuildingContactResponse>(
        buildingId: string,
        contactId: string,
        editBuildingContactRequest: EditBuildingContactRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    updateBuildingContact<TData = BuildingContactResponse>(
        buildingId: string,
        contactId: string,
        editBuildingContactRequest: EditBuildingContactRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}/contacts/${contactId}`,
                editBuildingContactRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}/contacts/${contactId}`,
                editBuildingContactRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.put<TData>(
            `/@core/api/buildings/${buildingId}/contacts/${contactId}`,
            editBuildingContactRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Lists the current active documents visible to the requester without creating an export job or reading file contents. It does not describe a previous ZIP export.
     * @summary Download a building handover transmittal as CSV
     */
    getBuildingDocumentExportTransmittalCsv(
        buildingId: string,
        options?: HttpClientBodyOptions
    ): Observable<Blob>;
    getBuildingDocumentExportTransmittalCsv(
        buildingId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<Blob>>;
    getBuildingDocumentExportTransmittalCsv(
        buildingId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<Blob>>;
    getBuildingDocumentExportTransmittalCsv(
        buildingId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<Blob>> {
        if (options?.observe === 'events') {
            return this.http.get(
                `/@core/api/buildings/${buildingId}/document-exports/transmittal.csv`,
                {
                    responseType: 'blob',
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            ) as Observable<HttpEvent<Blob>>;
        }

        if (options?.observe === 'response') {
            return this.http.get(
                `/@core/api/buildings/${buildingId}/document-exports/transmittal.csv`,
                {
                    responseType: 'blob',
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            ) as Observable<AngularHttpResponse<Blob>>;
        }

        return this.http.get(
            `/@core/api/buildings/${buildingId}/document-exports/transmittal.csv`,
            {
                responseType: 'blob',
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        ) as Observable<Blob>;
    }
    /**
     * @summary List building document packs
     */
    listBuildingDocumentPacks<TData = DocumentPackListResponse>(
        buildingId: string,
        params: ListBuildingDocumentPacksParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildingDocumentPacks<TData = DocumentPackListResponse>(
        buildingId: string,
        params: ListBuildingDocumentPacksParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingDocumentPacks<TData = DocumentPackListResponse>(
        buildingId: string,
        params: ListBuildingDocumentPacksParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingDocumentPacks<TData = DocumentPackListResponse>(
        buildingId: string,
        params: ListBuildingDocumentPacksParams,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-packs`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-packs`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/document-packs`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Creates an ordered document pack with sections, requirements and optional initial document assignments. Unavailable initial selections are skipped and reported by skippedRequirementIds without document metadata. Cross-building selections reject the request. The whole pack is saved atomically; status and progress are derived from assignments.
     * @summary Create building document pack
     */
    createBuildingDocumentPack<TData = CreateDocumentPackResponse>(
        buildingId: string,
        createDocumentPackRequest: CreateDocumentPackRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentPack<TData = CreateDocumentPackResponse>(
        buildingId: string,
        createDocumentPackRequest: CreateDocumentPackRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentPack<TData = CreateDocumentPackResponse>(
        buildingId: string,
        createDocumentPackRequest: CreateDocumentPackRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentPack<TData = CreateDocumentPackResponse>(
        buildingId: string,
        createDocumentPackRequest: CreateDocumentPackRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs`,
                createDocumentPackRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs`,
                createDocumentPackRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/document-packs`,
            createDocumentPackRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Delete building document pack
     */
    removeBuildingDocumentPack<TData = void>(
        buildingId: string,
        packId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    removeBuildingDocumentPack<TData = void>(
        buildingId: string,
        packId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    removeBuildingDocumentPack<TData = void>(
        buildingId: string,
        packId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    removeBuildingDocumentPack<TData = void>(
        buildingId: string,
        packId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.delete<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Get building document pack
     */
    getBuildingDocumentPackById<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingDocumentPackById<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingDocumentPackById<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingDocumentPackById<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Update building document pack
     */
    updateBuildingDocumentPack<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        updateDocumentPackRequest: UpdateDocumentPackRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    updateBuildingDocumentPack<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        updateDocumentPackRequest: UpdateDocumentPackRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    updateBuildingDocumentPack<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        updateDocumentPackRequest: UpdateDocumentPackRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    updateBuildingDocumentPack<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        updateDocumentPackRequest: UpdateDocumentPackRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}`,
                updateDocumentPackRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}`,
                updateDocumentPackRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.put<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}`,
            updateDocumentPackRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    listBuildingDocumentPackApprovals<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildingDocumentPackApprovals<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingDocumentPackApprovals<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingDocumentPackApprovals<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    createBuildingDocumentPackApproval<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        packApprovalParticipantsRequest: PackApprovalParticipantsRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentPackApproval<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        packApprovalParticipantsRequest: PackApprovalParticipantsRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentPackApproval<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        packApprovalParticipantsRequest: PackApprovalParticipantsRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentPackApproval<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        packApprovalParticipantsRequest: PackApprovalParticipantsRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals`,
                packApprovalParticipantsRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals`,
                packApprovalParticipantsRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals`,
            packApprovalParticipantsRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Search active users with current building access by name or organisation, including during initial approval setup.
     * @summary Search eligible pack approval participants
     */
    listBuildingDocumentPackApprovalCandidates<
        TData = PackApprovalCandidatesResponse,
    >(
        buildingId: string,
        packId: string,
        params?: ListBuildingDocumentPackApprovalCandidatesParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildingDocumentPackApprovalCandidates<
        TData = PackApprovalCandidatesResponse,
    >(
        buildingId: string,
        packId: string,
        params?: ListBuildingDocumentPackApprovalCandidatesParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingDocumentPackApprovalCandidates<
        TData = PackApprovalCandidatesResponse,
    >(
        buildingId: string,
        packId: string,
        params?: ListBuildingDocumentPackApprovalCandidatesParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingDocumentPackApprovalCandidates<
        TData = PackApprovalCandidatesResponse,
    >(
        buildingId: string,
        packId: string,
        params?: ListBuildingDocumentPackApprovalCandidatesParams,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals/candidates`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals/candidates`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals/candidates`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    getBuildingDocumentPackApprovalHistory<TData = PackApprovalHistoryResponse>(
        buildingId: string,
        packId: string,
        params?: GetBuildingDocumentPackApprovalHistoryParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingDocumentPackApprovalHistory<TData = PackApprovalHistoryResponse>(
        buildingId: string,
        packId: string,
        params?: GetBuildingDocumentPackApprovalHistoryParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingDocumentPackApprovalHistory<TData = PackApprovalHistoryResponse>(
        buildingId: string,
        packId: string,
        params?: GetBuildingDocumentPackApprovalHistoryParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingDocumentPackApprovalHistory<TData = PackApprovalHistoryResponse>(
        buildingId: string,
        packId: string,
        params?: GetBuildingDocumentPackApprovalHistoryParams,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals/history`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals/history`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals/history`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    updateBuildingDocumentPackApprovalParticipant<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        packApprovalParticipantsRequest: PackApprovalParticipantsRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    updateBuildingDocumentPackApprovalParticipant<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        packApprovalParticipantsRequest: PackApprovalParticipantsRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    updateBuildingDocumentPackApprovalParticipant<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        packApprovalParticipantsRequest: PackApprovalParticipantsRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    updateBuildingDocumentPackApprovalParticipant<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        packApprovalParticipantsRequest: PackApprovalParticipantsRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals/participants`,
                packApprovalParticipantsRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals/participants`,
                packApprovalParticipantsRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.put<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals/participants`,
            packApprovalParticipantsRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    removeBuildingDocumentPackApprovalParticipant<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        participantId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    removeBuildingDocumentPackApprovalParticipant<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        participantId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    removeBuildingDocumentPackApprovalParticipant<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        participantId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    removeBuildingDocumentPackApprovalParticipant<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        participantId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals/participants/${participantId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals/participants/${participantId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.delete<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals/participants/${participantId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    createBuildingDocumentPackApprovalReplacement<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        packApprovalReplacementRequest: PackApprovalReplacementRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentPackApprovalReplacement<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        packApprovalReplacementRequest: PackApprovalReplacementRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentPackApprovalReplacement<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        packApprovalReplacementRequest: PackApprovalReplacementRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentPackApprovalReplacement<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        packApprovalReplacementRequest: PackApprovalReplacementRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals/replacements`,
                packApprovalReplacementRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals/replacements`,
                packApprovalReplacementRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/approvals/replacements`,
            packApprovalReplacementRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Creates an independent checklist, optionally reusing eligible same-building document assignments without copying files. SkippedRequirementIds identifies requirements left empty because their assigned document was unavailable or ineligible.
     * @summary Duplicate building document pack
     */
    duplicateBuildingDocumentPack<TData = DuplicateDocumentPackResponse>(
        buildingId: string,
        packId: string,
        duplicateDocumentPackRequest: DuplicateDocumentPackRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    duplicateBuildingDocumentPack<TData = DuplicateDocumentPackResponse>(
        buildingId: string,
        packId: string,
        duplicateDocumentPackRequest: DuplicateDocumentPackRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    duplicateBuildingDocumentPack<TData = DuplicateDocumentPackResponse>(
        buildingId: string,
        packId: string,
        duplicateDocumentPackRequest: DuplicateDocumentPackRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    duplicateBuildingDocumentPack<TData = DuplicateDocumentPackResponse>(
        buildingId: string,
        packId: string,
        duplicateDocumentPackRequest: DuplicateDocumentPackRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/duplicate`,
                duplicateDocumentPackRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/duplicate`,
                duplicateDocumentPackRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/duplicate`,
            duplicateDocumentPackRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Start an asynchronous document pack ZIP export
     */
    createBuildingDocumentPackExport<TData = unknown>(
        buildingId: string,
        packId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentPackExport<TData = unknown>(
        buildingId: string,
        packId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentPackExport<TData = unknown>(
        buildingId: string,
        packId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentPackExport<TData = unknown>(
        buildingId: string,
        packId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/exports`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/exports`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/exports`,
            undefined,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Get document pack export status
     */
    getBuildingDocumentPackExportById<TData = DocumentExportStatusResponse>(
        buildingId: string,
        packId: string,
        jobId: string,
        params: GetBuildingDocumentPackExportByIdParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingDocumentPackExportById<TData = DocumentExportStatusResponse>(
        buildingId: string,
        packId: string,
        jobId: string,
        params: GetBuildingDocumentPackExportByIdParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingDocumentPackExportById<TData = DocumentExportStatusResponse>(
        buildingId: string,
        packId: string,
        jobId: string,
        params: GetBuildingDocumentPackExportByIdParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingDocumentPackExportById<TData = DocumentExportStatusResponse>(
        buildingId: string,
        packId: string,
        jobId: string,
        params: GetBuildingDocumentPackExportByIdParams,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/exports/${jobId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/exports/${jobId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/exports/${jobId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * @summary Download a completed document pack ZIP export
     */
    getBuildingDocumentPackExportDownload<TData = unknown>(
        buildingId: string,
        packId: string,
        jobId: string,
        params: GetBuildingDocumentPackExportDownloadParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingDocumentPackExportDownload<TData = unknown>(
        buildingId: string,
        packId: string,
        jobId: string,
        params: GetBuildingDocumentPackExportDownloadParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingDocumentPackExportDownload<TData = unknown>(
        buildingId: string,
        packId: string,
        jobId: string,
        params: GetBuildingDocumentPackExportDownloadParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingDocumentPackExportDownload<TData = unknown>(
        buildingId: string,
        packId: string,
        jobId: string,
        params: GetBuildingDocumentPackExportDownloadParams,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/exports/${jobId}/download`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/exports/${jobId}/download`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/exports/${jobId}/download`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * @summary Create a temporary download link for the current checklist CSV
     */
    createBuildingDocumentPackManifestLink<TData = unknown>(
        buildingId: string,
        packId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentPackManifestLink<TData = unknown>(
        buildingId: string,
        packId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentPackManifestLink<TData = unknown>(
        buildingId: string,
        packId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentPackManifestLink<TData = unknown>(
        buildingId: string,
        packId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/manifest-links`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/manifest-links`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/manifest-links`,
            undefined,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Returns one row per eligible attachment, or an outstanding row for a requirement with no eligible attachments. Available only when the building is published.
     * @summary Download the current document pack manifest as CSV
     */
    getBuildingDocumentPackManifestCsv(
        buildingId: string,
        packId: string,
        options?: HttpClientBodyOptions
    ): Observable<Blob>;
    getBuildingDocumentPackManifestCsv(
        buildingId: string,
        packId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<Blob>>;
    getBuildingDocumentPackManifestCsv(
        buildingId: string,
        packId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<Blob>>;
    getBuildingDocumentPackManifestCsv(
        buildingId: string,
        packId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<Blob>> {
        if (options?.observe === 'events') {
            return this.http.get(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/manifest.csv`,
                {
                    responseType: 'blob',
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            ) as Observable<HttpEvent<Blob>>;
        }

        if (options?.observe === 'response') {
            return this.http.get(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/manifest.csv`,
                {
                    responseType: 'blob',
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            ) as Observable<AngularHttpResponse<Blob>>;
        }

        return this.http.get(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/manifest.csv`,
            {
                responseType: 'blob',
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        ) as Observable<Blob>;
    }
    createBuildingDocumentPackRequirementDecision<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        requirementId: string,
        packApprovalDecisionRequest: PackApprovalDecisionRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentPackRequirementDecision<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        requirementId: string,
        packApprovalDecisionRequest: PackApprovalDecisionRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentPackRequirementDecision<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        requirementId: string,
        packApprovalDecisionRequest: PackApprovalDecisionRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentPackRequirementDecision<TData = PackApprovalResponse>(
        buildingId: string,
        packId: string,
        requirementId: string,
        packApprovalDecisionRequest: PackApprovalDecisionRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/decisions`,
                packApprovalDecisionRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/decisions`,
                packApprovalDecisionRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/decisions`,
            packApprovalDecisionRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Detach a document from a pack requirement
     */
    removeBuildingDocumentPackRequirementDocument<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        requirementId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    removeBuildingDocumentPackRequirementDocument<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        requirementId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    removeBuildingDocumentPackRequirementDocument<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        requirementId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    removeBuildingDocumentPackRequirementDocument<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        requirementId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/document`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/document`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.delete<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/document`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Upload or deduplicate a document and assign it to a pack requirement
     */
    uploadAndAssignDocumentPackDocumentLegacy<
        TData = UploadAndAssignDocumentPackResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        uploadAndAssignDocumentPackRequest: UploadAndAssignDocumentPackRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    uploadAndAssignDocumentPackDocumentLegacy<
        TData = UploadAndAssignDocumentPackResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        uploadAndAssignDocumentPackRequest: UploadAndAssignDocumentPackRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    uploadAndAssignDocumentPackDocumentLegacy<
        TData = UploadAndAssignDocumentPackResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        uploadAndAssignDocumentPackRequest: UploadAndAssignDocumentPackRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    uploadAndAssignDocumentPackDocumentLegacy<
        TData = UploadAndAssignDocumentPackResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        uploadAndAssignDocumentPackRequest: UploadAndAssignDocumentPackRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const formData = new FormData();
        formData.append(`file`, uploadAndAssignDocumentPackRequest.file);

        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/document`,
                formData,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/document`,
                formData,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/document`,
            formData,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Assign or replace a document pack requirement document
     */
    updateBuildingDocumentPackRequirementDocument<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        requirementId: string,
        assignDocumentPackDocumentRequest: AssignDocumentPackDocumentRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    updateBuildingDocumentPackRequirementDocument<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        requirementId: string,
        assignDocumentPackDocumentRequest: AssignDocumentPackDocumentRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    updateBuildingDocumentPackRequirementDocument<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        requirementId: string,
        assignDocumentPackDocumentRequest: AssignDocumentPackDocumentRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    updateBuildingDocumentPackRequirementDocument<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        requirementId: string,
        assignDocumentPackDocumentRequest: AssignDocumentPackDocumentRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/document`,
                assignDocumentPackDocumentRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/document`,
                assignDocumentPackDocumentRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.put<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/document`,
            assignDocumentPackDocumentRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Add a document to a pack requirement
     */
    assignDocumentPackDocument<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        requirementId: string,
        assignDocumentPackDocumentRequest: AssignDocumentPackDocumentRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    assignDocumentPackDocument<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        requirementId: string,
        assignDocumentPackDocumentRequest: AssignDocumentPackDocumentRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    assignDocumentPackDocument<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        requirementId: string,
        assignDocumentPackDocumentRequest: AssignDocumentPackDocumentRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    assignDocumentPackDocument<TData = DocumentPackResponse>(
        buildingId: string,
        packId: string,
        requirementId: string,
        assignDocumentPackDocumentRequest: AssignDocumentPackDocumentRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/documents`,
                assignDocumentPackDocumentRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/documents`,
                assignDocumentPackDocumentRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/documents`,
            assignDocumentPackDocumentRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Accepts one to five document IDs and atomically adds their distinct eligible documents without replacing existing attachments or pack structure. Duplicate IDs are collapsed; already attached documents are reported without changing the pack. The union of canonical stored attachments and requested documents cannot exceed five. All documents are validated before any assignment. Requires the current quoted pack version in If-Match even when every document is already attached; stale versions reject the entire request. Returns the canonical pack, ETag and one added or alreadyAttached outcome per distinct requested document in first-input order.
     * @summary Add a batch of existing documents to a pack requirement
     */
    assignDocumentPackDocumentsBatch<
        TData = AssignDocumentPackDocumentsBatchResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        assignDocumentPackDocumentsBatchRequest: AssignDocumentPackDocumentsBatchRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    assignDocumentPackDocumentsBatch<
        TData = AssignDocumentPackDocumentsBatchResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        assignDocumentPackDocumentsBatchRequest: AssignDocumentPackDocumentsBatchRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    assignDocumentPackDocumentsBatch<
        TData = AssignDocumentPackDocumentsBatchResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        assignDocumentPackDocumentsBatchRequest: AssignDocumentPackDocumentsBatchRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    assignDocumentPackDocumentsBatch<
        TData = AssignDocumentPackDocumentsBatchResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        assignDocumentPackDocumentsBatchRequest: AssignDocumentPackDocumentsBatchRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/documents/batch`,
                assignDocumentPackDocumentsBatchRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/documents/batch`,
                assignDocumentPackDocumentsBatchRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/documents/batch`,
            assignDocumentPackDocumentsBatchRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Upload or deduplicate a document and assign it to a pack requirement
     */
    createBuildingDocumentPackRequirementDocumentUpload<
        TData = UploadAndAssignDocumentPackResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        uploadAndAssignDocumentPackRequest: UploadAndAssignDocumentPackRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentPackRequirementDocumentUpload<
        TData = UploadAndAssignDocumentPackResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        uploadAndAssignDocumentPackRequest: UploadAndAssignDocumentPackRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentPackRequirementDocumentUpload<
        TData = UploadAndAssignDocumentPackResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        uploadAndAssignDocumentPackRequest: UploadAndAssignDocumentPackRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentPackRequirementDocumentUpload<
        TData = UploadAndAssignDocumentPackResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        uploadAndAssignDocumentPackRequest: UploadAndAssignDocumentPackRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const formData = new FormData();
        formData.append(`file`, uploadAndAssignDocumentPackRequest.file);

        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/documents/upload`,
                formData,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/documents/upload`,
                formData,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/documents/upload`,
            formData,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Provide one to five multipart Files with matching unique ClientFileIds (maximum 128 characters each), plus one current If-Match pack version. Validates the whole batch, deduplicates content and checks the union with canonical existing attachments before storage writes. At most five unique documents may be attached. Document creation, additive assignments and durable processing requests commit atomically. Any validation or precommit execution failure applies none of the batch; validation errors identify rejected inputs and inputs not applied. Returns canonical pack, ETag and one ordered outcome for every client file ID. Processing pending means durably prepared, not classified. After a lost response, reload canonical pack/version and retry; content deduplication and additive assignments preserve confirmed documents. Conflicts require canonical reload. Blobs from confirmed or uncertain commits are retained; failed precommit uploads are compensated on a best effort basis.
     * @summary Upload or deduplicate a batch of files and add them to a saved pack requirement
     */
    uploadAndAssignDocumentPackBatch<
        TData = UploadAndAssignDocumentPackBatchResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        uploadAndAssignDocumentPackBatchRequest: UploadAndAssignDocumentPackBatchRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    uploadAndAssignDocumentPackBatch<
        TData = UploadAndAssignDocumentPackBatchResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        uploadAndAssignDocumentPackBatchRequest: UploadAndAssignDocumentPackBatchRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    uploadAndAssignDocumentPackBatch<
        TData = UploadAndAssignDocumentPackBatchResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        uploadAndAssignDocumentPackBatchRequest: UploadAndAssignDocumentPackBatchRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    uploadAndAssignDocumentPackBatch<
        TData = UploadAndAssignDocumentPackBatchResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        uploadAndAssignDocumentPackBatchRequest: UploadAndAssignDocumentPackBatchRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const formData = new FormData();
        uploadAndAssignDocumentPackBatchRequest.clientFileIds.forEach((value) =>
            formData.append(`clientFileIds`, value)
        );
        uploadAndAssignDocumentPackBatchRequest.files.forEach((value) =>
            formData.append(`files`, value)
        );

        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/documents/upload-batch`,
                formData,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/documents/upload-batch`,
                formData,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/documents/upload-batch`,
            formData,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Detach a document from a pack requirement
     */
    removeBuildingDocumentPackRequirementDocument2<
        TData = DocumentPackResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        attachmentDocumentId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    removeBuildingDocumentPackRequirementDocument2<
        TData = DocumentPackResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        attachmentDocumentId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    removeBuildingDocumentPackRequirementDocument2<
        TData = DocumentPackResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        attachmentDocumentId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    removeBuildingDocumentPackRequirementDocument2<
        TData = DocumentPackResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        attachmentDocumentId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/documents/${attachmentDocumentId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/documents/${attachmentDocumentId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.delete<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/documents/${attachmentDocumentId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    createBuildingDocumentPackRequirementSubmission<
        TData = PackApprovalResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentPackRequirementSubmission<
        TData = PackApprovalResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentPackRequirementSubmission<
        TData = PackApprovalResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentPackRequirementSubmission<
        TData = PackApprovalResponse,
    >(
        buildingId: string,
        packId: string,
        requirementId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/submissions`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/submissions`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/requirements/${requirementId}/submissions`,
            undefined,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Shares the pack with one to 20 comma-delimited recipients and returns ordered per-recipient outcomes.
     * @summary Share a live document pack by authenticated email access
     */
    createBuildingDocumentPackShare<
        TData = RecipientBatchResponseOfShareDocumentPackResponse,
    >(
        buildingId: string,
        packId: string,
        shareDocumentPackRequest: ShareDocumentPackRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentPackShare<
        TData = RecipientBatchResponseOfShareDocumentPackResponse,
    >(
        buildingId: string,
        packId: string,
        shareDocumentPackRequest: ShareDocumentPackRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentPackShare<
        TData = RecipientBatchResponseOfShareDocumentPackResponse,
    >(
        buildingId: string,
        packId: string,
        shareDocumentPackRequest: ShareDocumentPackRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentPackShare<
        TData = RecipientBatchResponseOfShareDocumentPackResponse,
    >(
        buildingId: string,
        packId: string,
        shareDocumentPackRequest: ShareDocumentPackRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/shares`,
                shareDocumentPackRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/shares`,
                shareDocumentPackRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/shares`,
            shareDocumentPackRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Suggest existing documents for pack requirements
     */
    createBuildingDocumentPackSuggestion<
        TData = DocumentPackSuggestionsResponse,
    >(
        buildingId: string,
        packId: string,
        suggestDocumentPackDocumentsRequest: SuggestDocumentPackDocumentsRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentPackSuggestion<
        TData = DocumentPackSuggestionsResponse,
    >(
        buildingId: string,
        packId: string,
        suggestDocumentPackDocumentsRequest: SuggestDocumentPackDocumentsRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentPackSuggestion<
        TData = DocumentPackSuggestionsResponse,
    >(
        buildingId: string,
        packId: string,
        suggestDocumentPackDocumentsRequest: SuggestDocumentPackDocumentsRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentPackSuggestion<
        TData = DocumentPackSuggestionsResponse,
    >(
        buildingId: string,
        packId: string,
        suggestDocumentPackDocumentsRequest: SuggestDocumentPackDocumentsRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/suggestions`,
                suggestDocumentPackDocumentsRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-packs/${packId}/suggestions`,
                suggestDocumentPackDocumentsRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/document-packs/${packId}/suggestions`,
            suggestDocumentPackDocumentsRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Returns one page of sealed intake outcomes and live processing stages under current access. This is not an immutable terminal receipt; absent or inaccessible batches return 404.
     * @summary Get current document upload batch status
     */
    listBuildingDocumentProcessingReceiptStatus<
        TData = DocumentBatchStatusResponse,
    >(
        buildingId: string,
        batchId: string,
        params?: ListBuildingDocumentProcessingReceiptStatusParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildingDocumentProcessingReceiptStatus<
        TData = DocumentBatchStatusResponse,
    >(
        buildingId: string,
        batchId: string,
        params?: ListBuildingDocumentProcessingReceiptStatusParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingDocumentProcessingReceiptStatus<
        TData = DocumentBatchStatusResponse,
    >(
        buildingId: string,
        batchId: string,
        params?: ListBuildingDocumentProcessingReceiptStatusParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingDocumentProcessingReceiptStatus<
        TData = DocumentBatchStatusResponse,
    >(
        buildingId: string,
        batchId: string,
        params?: ListBuildingDocumentProcessingReceiptStatusParams,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-processing-receipts/${batchId}/status`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-processing-receipts/${batchId}/status`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/document-processing-receipts/${batchId}/status`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Returns the current generated-PDF preview lifecycle and active conversion attempt.
     * @summary Get generated document preview status
     */
    getBuildingDocumentPreview<TData = DocumentPreviewResponse>(
        buildingId: string,
        documentId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingDocumentPreview<TData = DocumentPreviewResponse>(
        buildingId: string,
        documentId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingDocumentPreview<TData = DocumentPreviewResponse>(
        buildingId: string,
        documentId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingDocumentPreview<TData = DocumentPreviewResponse>(
        buildingId: string,
        documentId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/preview`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/preview`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/documents/${documentId}/preview`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Records user feedback against the currently verified generated PDF preview attempt.
     * @summary Report incorrect generated document preview
     */
    createBuildingDocumentPreviewFeedback<
        TData = DocumentPreviewFeedbackResponse,
    >(
        buildingId: string,
        documentId: string,
        submitDocumentPreviewFeedbackRequest: SubmitDocumentPreviewFeedbackRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentPreviewFeedback<
        TData = DocumentPreviewFeedbackResponse,
    >(
        buildingId: string,
        documentId: string,
        submitDocumentPreviewFeedbackRequest: SubmitDocumentPreviewFeedbackRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentPreviewFeedback<
        TData = DocumentPreviewFeedbackResponse,
    >(
        buildingId: string,
        documentId: string,
        submitDocumentPreviewFeedbackRequest: SubmitDocumentPreviewFeedbackRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentPreviewFeedback<
        TData = DocumentPreviewFeedbackResponse,
    >(
        buildingId: string,
        documentId: string,
        submitDocumentPreviewFeedbackRequest: SubmitDocumentPreviewFeedbackRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/preview/feedback`,
                submitDocumentPreviewFeedbackRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/preview/feedback`,
                submitDocumentPreviewFeedbackRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/documents/${documentId}/preview/feedback`,
            submitDocumentPreviewFeedbackRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Queues a replacement generated-PDF preview attempt for a DWG document.
     * @summary Retry generated document preview conversion
     */
    createBuildingDocumentPreviewRetry<TData = DocumentPreviewRetryResponse>(
        buildingId: string,
        documentId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentPreviewRetry<TData = DocumentPreviewRetryResponse>(
        buildingId: string,
        documentId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentPreviewRetry<TData = DocumentPreviewRetryResponse>(
        buildingId: string,
        documentId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentPreviewRetry<TData = DocumentPreviewRetryResponse>(
        buildingId: string,
        documentId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/preview/retry`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/preview/retry`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/documents/${documentId}/preview/retry`,
            undefined,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Returns a short-lived authorized URL for an available, verified generated PDF preview.
     * @summary Get generated document preview view URL
     */
    getBuildingDocumentPreviewViewUrl<
        TData = DocumentPreviewViewUrlResponse | void,
    >(
        buildingId: string,
        documentId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingDocumentPreviewViewUrl<
        TData = DocumentPreviewViewUrlResponse | void,
    >(
        buildingId: string,
        documentId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingDocumentPreviewViewUrl<
        TData = DocumentPreviewViewUrlResponse | void,
    >(
        buildingId: string,
        documentId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingDocumentPreviewViewUrl<
        TData = DocumentPreviewViewUrlResponse | void,
    >(
        buildingId: string,
        documentId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/preview/view-url`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/preview/view-url`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/documents/${documentId}/preview/view-url`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Retrieves the current building integrity score summary and the overdue seeded ESM inspections impacting that score.
     * @summary Get building integrity details
     */
    listBuildingIntegrityDetails<TData = GetBuildingIntegrityDetailsResponse>(
        buildingId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildingIntegrityDetails<TData = GetBuildingIntegrityDetailsResponse>(
        buildingId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingIntegrityDetails<TData = GetBuildingIntegrityDetailsResponse>(
        buildingId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingIntegrityDetails<TData = GetBuildingIntegrityDetailsResponse>(
        buildingId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/integrity-details`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/integrity-details`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/integrity-details`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Retrieves the latest recorded building integrity score for each of the last 12 calendar months.
     * @summary Get building integrity trend
     */
    getBuildingIntegrityTrend<TData = GetBuildingIntegrityTrendResponse>(
        buildingId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingIntegrityTrend<TData = GetBuildingIntegrityTrendResponse>(
        buildingId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingIntegrityTrend<TData = GetBuildingIntegrityTrendResponse>(
        buildingId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingIntegrityTrend<TData = GetBuildingIntegrityTrendResponse>(
        buildingId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/integrity-trend`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/integrity-trend`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/integrity-trend`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Returns missing and outdated enrichment counts for supported visible documents and the requester's active job.
     * @summary Get building intelligence enrichment eligibility
     */
    getBuildingIntelligenceEnrichment<
        TData = BuildingIntelligenceEnrichmentEligibilityResponse,
    >(buildingId: string, options?: HttpClientBodyOptions): Observable<TData>;
    getBuildingIntelligenceEnrichment<
        TData = BuildingIntelligenceEnrichmentEligibilityResponse,
    >(
        buildingId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingIntelligenceEnrichment<
        TData = BuildingIntelligenceEnrichmentEligibilityResponse,
    >(
        buildingId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingIntelligenceEnrichment<
        TData = BuildingIntelligenceEnrichmentEligibilityResponse,
    >(
        buildingId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/intelligence/enrichment`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/intelligence/enrichment`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/intelligence/enrichment`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Atomically queues all eligible visible documents, preserving successful intelligence during replacement. Repeated activation reuses the requester's active job.
     * @summary Enrich missing and outdated building document intelligence
     */
    createBuildingIntelligenceEnrichment<
        TData = StartBuildingIntelligenceEnrichmentResponse,
    >(buildingId: string, options?: HttpClientBodyOptions): Observable<TData>;
    createBuildingIntelligenceEnrichment<
        TData = StartBuildingIntelligenceEnrichmentResponse,
    >(
        buildingId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingIntelligenceEnrichment<
        TData = StartBuildingIntelligenceEnrichmentResponse,
    >(
        buildingId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingIntelligenceEnrichment<
        TData = StartBuildingIntelligenceEnrichmentResponse,
    >(
        buildingId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/intelligence/enrichment`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/intelligence/enrichment`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/intelligence/enrichment`,
            undefined,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Returns durable progress for the requester, counting only documents still active and visible.
     * @summary Get building intelligence enrichment progress
     */
    getBuildingIntelligenceEnrichmentJobById<
        TData = BuildingIntelligenceEnrichmentJobResponse,
    >(
        buildingId: string,
        jobId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingIntelligenceEnrichmentJobById<
        TData = BuildingIntelligenceEnrichmentJobResponse,
    >(
        buildingId: string,
        jobId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingIntelligenceEnrichmentJobById<
        TData = BuildingIntelligenceEnrichmentJobResponse,
    >(
        buildingId: string,
        jobId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingIntelligenceEnrichmentJobById<
        TData = BuildingIntelligenceEnrichmentJobResponse,
    >(
        buildingId: string,
        jobId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/intelligence/enrichment/jobs/${jobId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/intelligence/enrichment/jobs/${jobId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/intelligence/enrichment/jobs/${jobId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Aggregates raw document enrichment snapshots into a paged building-level entity list for the requested type.
     * @summary Get building intelligence entities
     */
    listBuildingIntelligenceEntities<
        TData = GetBuildingIntelligenceEntitiesResponse,
    >(
        buildingId: string,
        params: ListBuildingIntelligenceEntitiesParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildingIntelligenceEntities<
        TData = GetBuildingIntelligenceEntitiesResponse,
    >(
        buildingId: string,
        params: ListBuildingIntelligenceEntitiesParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingIntelligenceEntities<
        TData = GetBuildingIntelligenceEntitiesResponse,
    >(
        buildingId: string,
        params: ListBuildingIntelligenceEntitiesParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingIntelligenceEntities<
        TData = GetBuildingIntelligenceEntitiesResponse,
    >(
        buildingId: string,
        params: ListBuildingIntelligenceEntitiesParams,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/intelligence/entities`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/intelligence/entities`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/intelligence/entities`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Returns a read-only persona proof report showing what the building can prove, partially prove, stale evidence, and missing evidence from completed document enrichment snapshots.
     * @summary Get persona proof report
     */
    getBuildingIntelligenceProofReport<TData = GetBuildingProofReportResponse>(
        buildingId: string,
        params?: GetBuildingIntelligenceProofReportParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingIntelligenceProofReport<TData = GetBuildingProofReportResponse>(
        buildingId: string,
        params?: GetBuildingIntelligenceProofReportParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingIntelligenceProofReport<TData = GetBuildingProofReportResponse>(
        buildingId: string,
        params?: GetBuildingIntelligenceProofReportParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingIntelligenceProofReport<TData = GetBuildingProofReportResponse>(
        buildingId: string,
        params?: GetBuildingIntelligenceProofReportParams,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/intelligence/proof-report`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/intelligence/proof-report`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/intelligence/proof-report`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Returns a read-only, source-backed building intelligence report from completed document enrichment snapshots.
     * @summary Get building intelligence report
     */
    getBuildingIntelligenceReport<
        TData = GetBuildingIntelligenceReportResponse,
    >(buildingId: string, options?: HttpClientBodyOptions): Observable<TData>;
    getBuildingIntelligenceReport<
        TData = GetBuildingIntelligenceReportResponse,
    >(
        buildingId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingIntelligenceReport<
        TData = GetBuildingIntelligenceReportResponse,
    >(
        buildingId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingIntelligenceReport<
        TData = GetBuildingIntelligenceReportResponse,
    >(
        buildingId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/intelligence/report`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/intelligence/report`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/intelligence/report`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Returns a thin paginated feed of document issue-date and expiry-date timeline events for a building.
     * @summary Get building intelligence timeline
     */
    getBuildingIntelligenceTimeline<
        TData = GetBuildingIntelligenceTimelineResponse,
    >(
        buildingId: string,
        params: GetBuildingIntelligenceTimelineParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingIntelligenceTimeline<
        TData = GetBuildingIntelligenceTimelineResponse,
    >(
        buildingId: string,
        params: GetBuildingIntelligenceTimelineParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingIntelligenceTimeline<
        TData = GetBuildingIntelligenceTimelineResponse,
    >(
        buildingId: string,
        params: GetBuildingIntelligenceTimelineParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingIntelligenceTimeline<
        TData = GetBuildingIntelligenceTimelineResponse,
    >(
        buildingId: string,
        params: GetBuildingIntelligenceTimelineParams,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/intelligence/timeline`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/intelligence/timeline`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/intelligence/timeline`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Counts accessible document issue and expiry dates in one year.
     * @summary Get building timeline calendar
     */
    getBuildingIntelligenceTimelineCalendar<
        TData = GetBuildingTimelineCalendarResponse,
    >(
        buildingId: string,
        params: GetBuildingIntelligenceTimelineCalendarParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingIntelligenceTimelineCalendar<
        TData = GetBuildingTimelineCalendarResponse,
    >(
        buildingId: string,
        params: GetBuildingIntelligenceTimelineCalendarParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingIntelligenceTimelineCalendar<
        TData = GetBuildingTimelineCalendarResponse,
    >(
        buildingId: string,
        params: GetBuildingIntelligenceTimelineCalendarParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingIntelligenceTimelineCalendar<
        TData = GetBuildingTimelineCalendarResponse,
    >(
        buildingId: string,
        params: GetBuildingIntelligenceTimelineCalendarParams,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/intelligence/timeline/calendar`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/intelligence/timeline/calendar`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/intelligence/timeline/calendar`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Retrieves a paginated building activity log for a building the authenticated user can access.
     * @summary List building log entries
     */
    getBuildingLog<TData = BuildingLogListResponse>(
        buildingId: string,
        params: GetBuildingLogParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingLog<TData = BuildingLogListResponse>(
        buildingId: string,
        params: GetBuildingLogParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingLog<TData = BuildingLogListResponse>(
        buildingId: string,
        params: GetBuildingLogParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingLog<TData = BuildingLogListResponse>(
        buildingId: string,
        params: GetBuildingLogParams,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/log`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/log`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(`/@core/api/buildings/${buildingId}/log`, {
            ...(options as Omit<NonNullable<typeof options>, 'observe'>),
            observe: 'body',
            params: filteredParams,
        });
    }
    /**
     * Counts building log actions by local date in the requested year and optional IANA timeZoneId. Defaults to UTC when omitted.
     * @summary Get building log calendar
     */
    getBuildingLogCalendar<TData = GetBuildingLogCalendarResponse>(
        buildingId: string,
        params: GetBuildingLogCalendarParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingLogCalendar<TData = GetBuildingLogCalendarResponse>(
        buildingId: string,
        params: GetBuildingLogCalendarParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingLogCalendar<TData = GetBuildingLogCalendarResponse>(
        buildingId: string,
        params: GetBuildingLogCalendarParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingLogCalendar<TData = GetBuildingLogCalendarResponse>(
        buildingId: string,
        params: GetBuildingLogCalendarParams,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/log/calendar`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/log/calendar`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/log/calendar`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Creates a pending ownership transfer request for a building without changing the current owner.
     * @summary Start a building ownership transfer
     */
    createBuildingOwnershipTransfer<TData = BuildingOwnershipTransferResponse>(
        buildingId: string,
        startBuildingOwnershipTransferRequest: StartBuildingOwnershipTransferRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingOwnershipTransfer<TData = BuildingOwnershipTransferResponse>(
        buildingId: string,
        startBuildingOwnershipTransferRequest: StartBuildingOwnershipTransferRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingOwnershipTransfer<TData = BuildingOwnershipTransferResponse>(
        buildingId: string,
        startBuildingOwnershipTransferRequest: StartBuildingOwnershipTransferRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingOwnershipTransfer<TData = BuildingOwnershipTransferResponse>(
        buildingId: string,
        startBuildingOwnershipTransferRequest: StartBuildingOwnershipTransferRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/ownership-transfers`,
                startBuildingOwnershipTransferRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/ownership-transfers`,
                startBuildingOwnershipTransferRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/ownership-transfers`,
            startBuildingOwnershipTransferRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Read-only exact-email lookup. Returns recognised, unknown or unavailable; only recognised includes an organisation name. The start-transfer command independently revalidates recipient eligibility.
     * @summary Preview an ownership-transfer recipient's organisation
     */
    createBuildingOwnershipTransferRecipientPreview<
        TData = OwnershipTransferRecipientPreviewResponse,
    >(
        buildingId: string,
        ownershipTransferRecipientPreviewRequest: OwnershipTransferRecipientPreviewRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingOwnershipTransferRecipientPreview<
        TData = OwnershipTransferRecipientPreviewResponse,
    >(
        buildingId: string,
        ownershipTransferRecipientPreviewRequest: OwnershipTransferRecipientPreviewRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingOwnershipTransferRecipientPreview<
        TData = OwnershipTransferRecipientPreviewResponse,
    >(
        buildingId: string,
        ownershipTransferRecipientPreviewRequest: OwnershipTransferRecipientPreviewRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingOwnershipTransferRecipientPreview<
        TData = OwnershipTransferRecipientPreviewResponse,
    >(
        buildingId: string,
        ownershipTransferRecipientPreviewRequest: OwnershipTransferRecipientPreviewRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/ownership-transfers/recipient-preview`,
                ownershipTransferRecipientPreviewRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/ownership-transfers/recipient-preview`,
                ownershipTransferRecipientPreviewRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/ownership-transfers/recipient-preview`,
            ownershipTransferRecipientPreviewRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Cancels the current owner organisation's pending request without changing building ownership or access.
     * @summary Cancel a pending building ownership transfer
     */
    createBuildingOwnershipTransferCancel<TData = void>(
        buildingId: string,
        transferId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingOwnershipTransferCancel<TData = void>(
        buildingId: string,
        transferId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingOwnershipTransferCancel<TData = void>(
        buildingId: string,
        transferId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingOwnershipTransferCancel<TData = void>(
        buildingId: string,
        transferId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/ownership-transfers/${transferId}/cancel`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/ownership-transfers/${transferId}/cancel`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/ownership-transfers/${transferId}/cancel`,
            undefined,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    getBuildingProfile<TData = GetBuildingProfileResponse>(
        buildingId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingProfile<TData = GetBuildingProfileResponse>(
        buildingId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingProfile<TData = GetBuildingProfileResponse>(
        buildingId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingProfile<TData = GetBuildingProfileResponse>(
        buildingId: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/profile`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/profile`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/profile`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    createBuildingProfileDecision<
        TData = DecideBuildingProfilePropertyResponse,
    >(
        buildingId: string,
        propertyKey: string,
        decideBuildingProfilePropertyRequest: DecideBuildingProfilePropertyRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingProfileDecision<
        TData = DecideBuildingProfilePropertyResponse,
    >(
        buildingId: string,
        propertyKey: string,
        decideBuildingProfilePropertyRequest: DecideBuildingProfilePropertyRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingProfileDecision<
        TData = DecideBuildingProfilePropertyResponse,
    >(
        buildingId: string,
        propertyKey: string,
        decideBuildingProfilePropertyRequest: DecideBuildingProfilePropertyRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingProfileDecision<
        TData = DecideBuildingProfilePropertyResponse,
    >(
        buildingId: string,
        propertyKey: string,
        decideBuildingProfilePropertyRequest: DecideBuildingProfilePropertyRequest,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/profile/${propertyKey}/decision`,
                decideBuildingProfilePropertyRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/profile/${propertyKey}/decision`,
                decideBuildingProfilePropertyRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/profile/${propertyKey}/decision`,
            decideBuildingProfilePropertyRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    getBuildingProfileEvidence<TData = BuildingProfileEvidenceIndexResponse>(
        buildingId: string,
        propertyKey: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingProfileEvidence<TData = BuildingProfileEvidenceIndexResponse>(
        buildingId: string,
        propertyKey: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingProfileEvidence<TData = BuildingProfileEvidenceIndexResponse>(
        buildingId: string,
        propertyKey: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingProfileEvidence<TData = BuildingProfileEvidenceIndexResponse>(
        buildingId: string,
        propertyKey: string,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/profile/${propertyKey}/evidence`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/profile/${propertyKey}/evidence`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/profile/${propertyKey}/evidence`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    listBuildingProfileEvidenceSources<
        TData = BuildingProfileEvidenceSourcesResponse,
    >(
        buildingId: string,
        propertyKey: string,
        optionId: string,
        params: ListBuildingProfileEvidenceSourcesParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildingProfileEvidenceSources<
        TData = BuildingProfileEvidenceSourcesResponse,
    >(
        buildingId: string,
        propertyKey: string,
        optionId: string,
        params: ListBuildingProfileEvidenceSourcesParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingProfileEvidenceSources<
        TData = BuildingProfileEvidenceSourcesResponse,
    >(
        buildingId: string,
        propertyKey: string,
        optionId: string,
        params: ListBuildingProfileEvidenceSourcesParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingProfileEvidenceSources<
        TData = BuildingProfileEvidenceSourcesResponse,
    >(
        buildingId: string,
        propertyKey: string,
        optionId: string,
        params: ListBuildingProfileEvidenceSourcesParams,
        options?: HttpClientObserveOptions
    ): Observable<AngularHttpClientResult<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/profile/${propertyKey}/evidence/${optionId}/sources`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/profile/${propertyKey}/evidence/${optionId}/sources`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/profile/${propertyKey}/evidence/${optionId}/sources`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
}
